import React, { useEffect, useState } from "react";
import ManualEmailSender from "./ManualEmailSender";
import SenderProfilesManager from "./SenderProfilesManager";
import EmailMessagesPanel from "./EmailMessagesPanel";

export default function EmailCenterTab() {
  const [innerTab, setInnerTab] = useState("manual");
  const [profiles, setProfiles] = useState([]);
  const [permissions, setPermissions] = useState([]);

  const loadProfiles = async () => {
    try {
      const res = await fetch("/api/admin/email/sender-profiles");
      const data = await res.json().catch(() => ({}));
      setProfiles(data.profiles || []);
      setPermissions(data.permissions || []);
    } catch (err) {
      console.error("Не удалось загрузить sender profiles", err);
      setProfiles([]);
      setPermissions([]);
    }
  };

  useEffect(() => {
    loadProfiles();
  }, []);

  const defaultProfile = profiles.find((p) => p.is_default) || profiles[0];

  return (
    <div style={{ padding: 8 }}>
      <div style={{ display: "flex", gap: 8, marginBottom: 8 }}>
        <button onClick={() => setInnerTab("manual")}>Ручная отправка</button>
        <button onClick={() => setInnerTab("messages")}>Все письма</button>
        <button onClick={() => setInnerTab("senders")}>Профили отправителей</button>
      </div>

      {innerTab === "manual" && (
        <ManualEmailSender
          senderProfiles={profiles}
          defaultSenderProfileId={defaultProfile ? String(defaultProfile.id) : ""}
        />
      )}

      {innerTab === "messages" && <EmailMessagesPanel />}

      {innerTab === "senders" && (
        <SenderProfilesManager profiles={profiles} permissions={permissions} onReload={loadProfiles} />
      )}
    </div>
  );
}
